// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen1/styles.scss
// module id = 384
// module chunks = 0